<form autocomplete="off" #armForm="ngForm">
  <div class="main-form">
    <ng-content></ng-content>
    <ac-line-separator></ac-line-separator>
    <div class="form-submit-button">
      <ac-button (click)="onSubmit()" [ngDisabled]="isSubmitDisabled" [buttonId]="buttonLabel ? buttonLabel : 'submit'">
        {{buttonLabel || 'Submit'}}
      </ac-button>
    </div>
  </div>
</form>
